import { Component, OnInit, Input, TemplateRef, ElementRef, ViewChild, AfterViewInit, AfterContentInit } from '@angular/core';

@Component({
  selector: 'sw-tab',
  templateUrl: './sw-tab.component.html',
  styleUrls: ['./sw-tab.component.css']
})
export class SwTabComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  @Input()
  /**
   * 选项卡标题 
   */
  title:string="";

  /**
   * 禁用
   */
  @Input() disabled:boolean =false;
  @ViewChild('tabSlide') tabTpl:ElementRef<any>;
}
